import { Container, Text } from './styles';

type Props = {
	text: string;
};

export const GeneratorHeading = ({ text }: Props) => (
	<Container>
		<Text>{text}</Text>
	</Container>
);
